import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        url: String
    }

    connect() {
        // console.log(this.urlValue)
        // Turbo.visit(this.urlValue,{  turbo: true, acceptsStreamResponse: true });
        fetch(this.urlValue, {
            headers: {
                Accept: "text/vnd.turbo-stream.html",
            },
        }).then(r => r.text())
            .then(html => Turbo.renderStreamMessage(html))
    }

}

